import { render, staticRenderFns } from "./vista-matriz.vue?vue&type=template&id=19a6410a"
import script from "./vista-matriz.vue?vue&type=script&lang=js"
export * from "./vista-matriz.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports